module.exports = __webpack_public_path__ + "static/img/product5-4.cead2e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product5-4.jpg
// module id = p0Bm
// module chunks = 0